import { MenuOptionGroupProps } from '@chakra-ui/menu';
import { chakra, forwardRef, HTMLChakraProps, useStyles } from '@chakra-ui/system';
import { Menu } from '@lego/klik-ui-menu';
import * as React from 'react';
import {
  IDropdownSelectionIndicatorAlignment,
  IDropdownSelectionIndicatorType,
  IDropdownSizes,
} from './DropdownTypes';
import { useDropdownOptionGroup } from './useDropdownOptionGroup';

const MenuGroup = forwardRef<HTMLChakraProps<'div'>, 'div'>((props, ref) => {
  const { title, children, width, ...rest } = props;
  const styles = useStyles();

  const minW = width ?? '100%';
  const maxW = width ?? 'fit-content';

  return (
    <chakra.div
      data-klik-indent={title ? 'true' : 'false'}
      maxW={maxW}
      minW={minW}
      ref={ref}
      role="group"
      width={width}
    >
      {title && (
        <chakra.p {...rest} __css={styles.groupTitle}>
          {title}
        </chakra.p>
      )}
      {children}
    </chakra.div>
  );
});

export interface IDropdownGroupProps extends MenuOptionGroupProps {
  selectionIndicator?: IDropdownSelectionIndicatorType;
  selectionIndicatorAlignment?: IDropdownSelectionIndicatorAlignment;
  size?: IDropdownSizes;
  onOptionSelected?: (value: string[] | string, group: string) => void;
  isMultiple?: boolean;
  width?: string;
  groupid?: string;
}

export const DropdownGroup: React.FunctionComponent<IDropdownGroupProps> = (props) => {
  const { title, ...rest } = props;
  const { groupid } = props;
  const ownProps = useDropdownOptionGroup(rest);

  const insertDivider = title && groupid !== 'grp-0';

  return (
    <React.Fragment>
      {insertDivider && <Menu.Divider />}
      <MenuGroup title={title} {...ownProps} />
    </React.Fragment>
  );
};
